import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';

var Sidebar = function Sidebar(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      logo = _ref.logo,
      logoHref = _ref.logoHref,
      logoAlt = _ref.logoAlt,
      headerText = _ref.headerText,
      subHeaderText = _ref.subHeaderText,
      descriptionText = _ref.descriptionText,
      showContact = _ref.showContact,
      contactHref = _ref.contactHref;
  return React.createElement('div', {
    className: "Sidebar ".concat(className)
  }, React.createElement('div', null, React.createElement(Link, {
    to: '/'
  }, React.createElement('img', {
    src: logo,
    alt: logoAlt,
    className: 'Sidebar-logo'
  }))), React.createElement('div', {
    className: 'Sidebar-header'
  }, headerText), React.createElement('div', {
    className: 'Sidebar-subheader'
  }, subHeaderText), React.createElement('div', {
    className: 'Sidebar-description'
  }, descriptionText), showContact && React.createElement('div', {
    className: 'Sidebar-contact'
  }, React.createElement('span', null, 'Need help?'), React.createElement(Link, {
    to: contactHref
  }, 'Contact us now!')));
};

Sidebar.propTypes = {
  className: PropTypes.string,
  logo: PropTypes.string,
  logoHref: PropTypes.string,
  headerText: PropTypes.node,
  subHeaderText: PropTypes.node,
  descriptionText: PropTypes.node,
  showContact: PropTypes.bool,
  contactHref: PropTypes.string
};
Sidebar.defaultProps = {
  className: '',
  logoHref: '/',
  showContact: false,
  contactHref: '/contact'
};
export default Sidebar;